import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthRoute = (props) => {
  const token = localStorage.getItem("accessToken");
  const { role } = useSelector((state) => state.Login);
  const currentPath = window.location.pathname;

  // Allow access to email-verify and reset-password pages even when logged in
  if (
    currentPath === "/email-verify" ||
    currentPath.startsWith("/reset-password")
  ) {
    return <React.Fragment>{props.children}</React.Fragment>;
  }

  // If user is logged in, redirect to their specific dashboard
  if (token) {
    // Fallback to localStorage if Redux role is not available
    let userRole = role;
    if (!role) {
      const userStr = localStorage.getItem("user");
      let user = null;
      try {
        user = userStr ? JSON.parse(userStr) : null;
        if (user?.is_admin === "1" || user?.is_admin === true) {
          userRole = "admin";
        } else if (user?.is_resturant === true || user?.is_resturant === "1") {
          userRole = "restaurant";
        } else {
          userRole = "customer";
        }
      } catch (e) {
        console.error("Failed to parse user data:", e);
        userRole = "customer";
      }
    }

    // Redirect to appropriate dashboard based on role
    if (userRole === "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (userRole === "restaurant") {
      return <Navigate to="/restaurant/dashboard" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // If not logged in, show the auth page
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default AuthRoute;
